import React from 'react';
import { IconName } from '@agilepoint/web-components';

export type IconSize = '8' | '10' | '12' | '14' | '16' | '20' | '24' | '28' | '32' | '36' | '40' | '44' | '48' | '52' |
    '56' | '60' | '64' | '68' | '72' | '76' | '80' | '84' | '88' | '92' | '96' | '100' | '104' | '108' | '112' | '116' |
    '120' | '124' | '128' | '132' | '136' | '140' | '144' | '148' | '152' | '156' | '160' | '164' | '168' | '172' |
    '176' | '180' | '184' | '188' | '192' | '196' | '200' | '204' | '208' | '212' | '216' | '220' | '224' | '228' |
    '232' | '236' | '240' | '244' | '248' | '252' | '256' | '260' | '264' | '268' | '272' | '276' | '280' | '284' |
    '288' | '292' | '296' | '300' | '304' | '308' | '312' | '316' | '320' | '324' | '328' | '332' | '336' | '340' |
    '344' | '348' | '352' | '356' | '360' | '364' | '368' | '372' | '376' | '380' | '384' | '388' | '392' | '396' |
    '400' | '404' | '408' | '412' | '416' | '420' | '424' | '428' | '432' | '436' | '440' | '444' | '448' | '452' |
    '456' | '460' | '464' | '468' | '472' | '476' | '480' | '484' | '488' | '492' | '496' | '500' | '504' | '508' | '512';

export type { IconName };

export interface IIconBaseProps {
    /**
     * Name of the Icon
     */
    iconName?: IconName;
    /**
     * Size of the Icon
     */
    iconSize?: IconSize;
}

export interface IIconProps extends IIconBaseProps {
    /**
     * Hide the component
     */
    hidden?: boolean;
    onClick?(ev: React.MouseEvent): void;
}
